// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__Rq3ti","line":"Tabs_line__MkpyO","tabs":"Tabs_tabs__ximJZ","card":"Tabs_card__65O7y","dark":"Tabs_dark__IViiX"};